// reCAPTCHA Enterprise for the backend-mediated login (/v1/auth/login).
// The Firebase SDK protects its own calls; this covers our custom one: the
// token is executed against the Identity Platform managed web key and passed
// through the backend to signInWithPassword as `captchaResponse`.
const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

let scriptPromise = null;

const loadRecaptcha = () => {
  if (!SITE_KEY) return Promise.reject(new Error('no site key'));
  if (window.grecaptcha?.enterprise) return Promise.resolve();
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = `https://www.google.com/recaptcha/enterprise.js?render=${SITE_KEY}`;
      s.async = true;
      s.onload = resolve;
      s.onerror = () => { scriptPromise = null; reject(new Error('recaptcha script failed')); };
      document.head.appendChild(s);
    });
  }
  return scriptPromise;
};

// Resolves to a token, or null if reCAPTCHA is unavailable — the backend
// forwards the token only when present, so AUDIT mode keeps working without it.
export const getRecaptchaToken = async (action) => {
  try {
    await loadRecaptcha();
    await new Promise((resolve) => window.grecaptcha.enterprise.ready(resolve));
    return await window.grecaptcha.enterprise.execute(SITE_KEY, { action });
  } catch (e) {
    return null;
  }
};
